import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { COLORES } from '../../../config/colores'
import { Dialog, Button, Tooltip } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'
import InfoIcon from '@material-ui/icons/Info'
import CantidadProductosPorCereal from './reporteCamiones/CantidadProductosPorCereal'
import TablaCamionesEntreBrutoYDestare from '../../Camiones/containers/listados/camionesEntreBrutoYDestare/containers/TablaCamionesEntreBrutoYDestare'
import InfoAutodescargables from './reporteCamiones/InfoAutodescargables'

function ReporteEntreBrutoDestare (props) {
  const { camEntreBrutoDestare, dialogOpen } = props
  const [open, setOpen] = useState(false)
  const [totalProductos, setTotalProductos] = useState(null)
  const [productosPorCalle, setProductosPorCalle] = useState([])
  const [calificacionProductos, setCalificacionProductos] = useState([])
  const [camionesVolcados, setCamionesVolcados] = useState([])
  const [autodescargables, setAutodescargables] = useState([])

  useEffect(() => {
    function setUp () {
      if (camEntreBrutoDestare.length > 0) {
        const total = camEntreBrutoDestare.length
        setTotalProductos(total)

        const camAutodescargables = camEntreBrutoDestare.filter((c) => c.autodescargable)

        const calles = []
        const calificaciones = []

        const volcados = camEntreBrutoDestare.filter((c) => c.volcadoraCamiones !== null)
        const productosListos = camEntreBrutoDestare.reduce((prod, camion) => {
          const { claveCereal, calificacionCereal, calleDeVolcadora, volcadoraCamiones, cerealVariedad } = camion

          // si no estan volcados
          if (!volcadoraCamiones) {
            const calleExiste = calles.find(calle => calle.calle === calleDeVolcadora && calle.cereal === claveCereal)
            const existeCalificacion = calificaciones.find(c => c.cereal === claveCereal && c.calificacion === calificacionCereal)

            if (!existeCalificacion && calificacionCereal) {
              const cantidadCalificacion = camEntreBrutoDestare.filter((p) => p.claveCereal === claveCereal && p.calificacionCereal === calificacionCereal && !p.volcadoraCamiones)
              calificaciones.push({
                cereal: claveCereal,
                cerealVariedad: cerealVariedad,
                calificacion: calificacionCereal,
                cantidad: cantidadCalificacion.length
              })
            }

            if (!calleExiste) {
              const cantidad = camEntreBrutoDestare.filter((p) => p.calleDeVolcadora === calleDeVolcadora && p.claveCereal === claveCereal && !p.volcadoraCamiones)
              calles.push({ calle: calleDeVolcadora, cereal: claveCereal, cantidad: cantidad.length })
            }
          }

          return calles
        }, [])
        setCalificacionProductos(calificaciones)
        setProductosPorCalle(productosListos)
        setCamionesVolcados(volcados)
        setAutodescargables(camAutodescargables)

        productosListos.sort((a, b) => {
          return a.cereal.localeCompare(b.cereal)
        })
      }
    }

    setUp()
  }, [camEntreBrutoDestare])

  const handleClose = () => {
    setOpen(false)
    dialogOpen(true)
  }

  const handleOpen = () => {
    setOpen(true)
    dialogOpen(true)
  }

  const detalleProductos = () => {
    if (calificacionProductos.length > 0) {
      return (
        <div>
          <Tooltip title={<>
            <h6>Detalle de productos sin volcado</h6>
            { calificacionProductos.map((c, i) => {
              return (
                <div key={i}>
                  <b>{c.cereal}</b> - {c.calificacion} : <b>{c.cantidad}</b>
                </div>
              )
            })}
          </>
          }
          >

            <InfoIcon style={{ color: COLORES.grey.dark, margin: '0 8px' }} />
          </Tooltip>
        </div>
      )
    } else {
      return null
    }
  }

  const contenidoAutodescargables = () => {
    const filtroInicial = [
      {
        name: 'autodescargable',
        filterList: ['Si']
      }
    ]
    return <TablaCamionesEntreBrutoYDestare filtroInicial={filtroInicial} />
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Camiones entre bruto y destare'
          content={<TablaCamionesEntreBrutoYDestare />}
        />
      </Dialog>

      <CantidadProductosPorCereal
        productosPorCereal={productosPorCalle}
        titulo='Entre bruto y destare'
        tituloTotal='Total'
        totalProductos={totalProductos}
        detalleProductos={detalleProductos}
      />

      { autodescargables &&
        <InfoAutodescargables
          productos={autodescargables}
          contenido={contenidoAutodescargables}
          titulo='Camiones autodescargables entre bruto y destare'
        />
      }

      { camionesVolcados.length > 0 ? <h6>Camiones con volcado: <b>{camionesVolcados.length}</b></h6> : <></> }

      <Button
        size='small'
        className='btn-reportes-bruto'
        variant='contained'
        style={{ color: '#ffffff', backgroundColor: COLORES.grey.dark, borderRadius: '22px', margin: '0 auto' }}
        onClick={handleOpen}
      >

             Entre bruto y destare
      </Button>

    </>
  )
}

const mapStateToProps = (state) => ({
  camEntreBrutoDestare: state.camionesIngreso.camEntreBrutoDestare
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(ReporteEntreBrutoDestare)
